import Marquee from "react-fast-marquee";

/**
 * Slow editorial marquee band — Playfair oversized headline that scrolls.
 */
export default function EditorialMarquee() {
  const words = [
    "Weddings",
    "Engagements",
    "Corporate",
    "Private Parties",
    "Custom Décor",
    "Ceremony",
    "Ateliers",
  ];
  return (
    <section aria-hidden="true" className="relative overflow-hidden border-y border-[#D4AF37]/25 bg-[#1A050B] py-10 md:py-14">
      <Marquee speed={35} gradient={false} pauseOnHover={false}>
        {words.concat(words).map((w, i) => (
          <span
            key={`${w}-${i}`}
            className="mx-10 inline-flex items-center gap-10 font-serif italic text-[12vw] leading-none tracking-[-0.02em] md:text-[9vw]"
          >
            <span className={i % 2 === 0 ? "text-[#FDFBF7]" : "text-stroke-gold"}>
              {w}
            </span>
            <span className="text-[#D4AF37] text-[6vw] md:text-[4vw]">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
